"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLoader = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

/* eslint-disable import/prefer-default-export */
var StyledLoader = _styledComponents["default"].div.withConfig({
  displayName: "Elements__StyledLoader",
  componentId: "sc-1vbumce-0"
})(["height:22px;@keyframes rotation{from{transform:rotate(0deg);}to{transform:rotate(359deg);}}display:", ";align-items:center;justify-content:center;> span{height:16px;width:16px;}svg{animation:rotation 2s infinite linear;width:16px;height:16px;}"], function (props) {
  return props.visible ? 'flex' : 'none';
});

exports.StyledLoader = StyledLoader;